// @flow

import styled from 'styled-components';

import animatedContent from '../../helpers/animatedContent';

import Row from './Row';

export default styled(Row)`
  ${animatedContent}
`;
